import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Scrollbars } from 'react-custom-scrollbars';
import ReactTooltip from 'react-tooltip';
import InfoBlue from '../../../../assets/img/info-blue.svg';
import EquityFocusIcon from '../../../../assets/img/focus.png';

const EquityFocus = ( props ) => {
  const {
    classes, filters, isLoading, checkedListAll, handleEquityFocusFilterTest,
  } = props;

  const [open, setOpen] = useState( !!( checkedListAll && checkedListAll.length > 0 ) );

  const handleClick = () => {
    setOpen( !open );
  };

  const renderEquityFocus = ( equityfocus ) => equityfocus.map( ( info ) => {
    let checked = false;
    let list = '';
    if ( checkedListAll && checkedListAll.indexOf( info.key ) > -1 ) {
      checked = true;
    }
    if ( info.key !== '' ) {
      list = (
        <ListItem button className={classes.nested} key={info.key}>
          <ListItemText className={classes.filterItem}>
            <FormControlLabel
              className={classes.checkBox}
              control={(
                <Checkbox
                  value={info.key}
                  classes={{
                    root: classes.checkBox,
                    checked: classes.checked,
                  }}
                  checked={checked}
                  onClick={!isLoading && handleEquityFocusFilterTest}
                  disabled={isLoading}
                  disableRipple
                />
                    )}
              label={`${info.key} (${info.doc_count})`}
            />
          </ListItemText>
        </ListItem>
      );
    }
    return list;
  } );

  return (
    <List className={classes.filterMenu}>
      <ListItem button onClick={handleClick} className={classes.filterHead}>
        <ListItemText>
          <img src={EquityFocusIcon} alt="" />
          {' '}
          Equity Focus
          <img data-for="equityFocusInfo" data-event="click focus mouseover" data-tip className={classes.infoIcon} src={InfoBlue} alt="" />
          <ReactTooltip id="equityFocusInfo" className={classNames( classes.reactTooltip, classes.reactTooltipClickableLink )} globalEventOff="mouseover" place="right" type="light" effect="solid">
            <span>
              Equity focus indicates whether gender or equity is considered in a study. And if yes, then how exactly? E.g. equity sensitive methodology, sub-group analysis. More informattion in the
              {' '}
              <a href="https://developmentevidence.3ieimpact.org/about-us" rel="noopener noreferrer" target="_blank">About the repository</a>
              {' '}
              section.
            </span>
          </ReactTooltip>
        </ListItemText>
        {
          open ? <i className="fa fa-caret-up" aria-hidden="true" /> : <i className="fa fa-caret-down" aria-hidden="true" />
        }
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.filterMenuBlock}>
        <div className={classes.maxHeightScroll}>
          <Scrollbars autoHeight>
            <List component="div" disablePadding>
              {
            filters
              ? (
                renderEquityFocus( filters )
              )
              : ( <span className={classes.noFiltersFound}>No filters for Equity Focus</span> )
          }
            </List>
          </Scrollbars>
        </div>
      </Collapse>
    </List>
  );
};

EquityFocus.defaultProps = {
  filters: null,
  isLoading: false,
  checkedListAll: null,
};

EquityFocus.propTypes = {
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  filters: PropTypes.arrayOf( PropTypes.object ),
  handleEquityFocusFilterTest: PropTypes.func.isRequired,
  checkedListAll: PropTypes.arrayOf( PropTypes.string ),
};

export default EquityFocus;
